export default "__VITE_ASSET__Cgr$u$jb__"